/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limit_1_TermInputs */

const en_svc_research_limit_1_term = /** @type {(inputs: Svc_Research_Limit_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No claim without a source`)
};

const lv_svc_research_limit_1_term = /** @type {(inputs: Svc_Research_Limit_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neviena apgalvojuma bez avota`)
};

/**
* | output |
* | --- |
* | "No claim without a source" |
*
* @param {Svc_Research_Limit_1_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limit_1_term = /** @type {((inputs?: Svc_Research_Limit_1_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limit_1_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limit_1_term(inputs)
	return en_svc_research_limit_1_term(inputs)
});